import React from 'react'
import { useRouter } from 'next/router'

import { getSession } from 'utils/auth'
import useMoengage from 'utils/hooks/useMoengage'

const EXCLUDED_PREFIXES = ['/gnn']

const MoEngageWrapper: React.FC = ({ children }) => {
  const router = useRouter()
  const session = getSession()

  // ✅ Exclude if pathname starts with any excluded prefix
  const isExcluded = EXCLUDED_PREFIXES.some((prefix) =>
    router.pathname.startsWith(prefix)
  )

  useMoengage(
    session
      ? {
          email: session.user.email,
          fullName: session.user.name,
          id: session.user.id,
        }
      : null,
    session?.expiredAt,
    isExcluded
  )

  return <>{children}</>
}

export default MoEngageWrapper
